export const MainButton = ({
  type,
  onClick,
  disabled,
  children,
  className,
}) => {
  return (
    <button
      type={type}
      className={`btn btn-secondary ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
